import { IPairingEventStatus, IEventStatus } from "../BuildStatus";
import { ShortCodeChip } from "src/components/ShortCodes/ShortCodeChip";
import classNames from "classnames";
import { StatusIcon } from "../StatusIcon";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { PendingEventStatus } from "./PendingEventStatus";
import { Grid } from "@mui/material";

interface IPendingPairingProps {
  pairing: IPairingEventStatus;
  tempShortCode: string;
}

export const PendingPairingStatus = (props: IPendingPairingProps): JSX.Element => {
  const { pairing, tempShortCode } = props;
  const { status, statusMessage, _id, shortId, flights } = pairing;

  return (
    <Grid container className={classNames("event_status", status)}>
      <Grid container wrap="nowrap" style={{ width: "auto " }}>
        <div className="pending_chip">
          <ShortCodeChip code={shortId ?? tempShortCode} itemId={_id} type="pairing" />
        </div>
        <div className="status_message">
          <DoubleArrowIcon className="status_arrow" />
          <StatusIcon className="status_icon" state={status} tooltipMessage={statusMessage} />
        </div>
      </Grid>

      <div className="pending_events">
        {flights?.map((nestedEvent: IEventStatus, index: number) => {
          return (
            <div key={`event_${index}_id${nestedEvent?._id}`} className="pending_event">
              <PendingEventStatus {...nestedEvent} />
            </div>
          );
        })}
      </div>
    </Grid>
  );
};
